const translations = {
    connectionError: 'Connection Error',
    saveFailed: 'Save Failed'
};

export default translations;
